import {Component, OnInit} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {CognitoService} from "../../cognito.service";
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {LoginShareDataService} from "../../services/login-share-data.service";
import { confirmResetPassword } from 'aws-amplify/auth';
import {ActivatedRoute, Router} from "@angular/router";
import { environment } from "src/environments/environment";
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  resetForm: FormGroup;
  showPasswords = {
    password: false,
    confirmPassword: false
  };
  errorMessage: string = '';
  public environment = environment;

  constructor(
      public projectTitle: Title,
      private nav: NavBarComponent,
      private cognitoService: CognitoService,
      private formBuilder: FormBuilder,
      private loginSharedDataService: LoginShareDataService,
      private router: Router,
      private route: ActivatedRoute
  ) {
  }

  matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      const control = abstractControl.get(controlName);
      const matchingControl = abstractControl.get(matchingControlName);

      if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
        return null;
      }

      if (control!.value !== matchingControl!.value) {
        const error = {confirmedValidator: 'Passwords do not match.'};
        matchingControl!.setErrors(error);
        return error;
      } else {
        matchingControl!.setErrors(null);
        return null;
      }
    }
  }

  ngOnInit() {
    const email = this.route.snapshot.paramMap.get('email');
    // console.log(email);
    this.resetForm = this.formBuilder.group({
      email: [email, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=\S+$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).+$/)]],
      confirmPassword: [null, Validators.required],
      code: [null, [Validators.required]],
    }, {validators: this.matchValidator('password', 'confirmPassword')});

    this.loginSharedDataService.emailDetailData.subscribe((res) => {
      if(res) {
        this.resetForm.get('email').setValue(res);
      }
    })
  }

  async resetPassword() {
    this.resetForm.markAllAsTouched();
    this.errorMessage = '';

    if(this.resetForm.valid && (this.resetForm.value.password === this.resetForm.value.confirmPassword)) {
      try {
        await confirmResetPassword({
          username: this.resetForm.value.email.toLowerCase(),
          confirmationCode: this.resetForm.value.code,
          newPassword: this.resetForm.value.password
        });

        this.router.navigateByUrl('/login')
      } catch(error) {
        this.errorMessage = error?.message;
      }
    }
  }
}
